import loggingService from '@/services/util/loggingService'
import roleService from '@/services/roleService'
import _ from 'lodash/lodash.min.js'

var serviceName = 'userService'
var path = '/User/'
var isDebug = false
const adminCountyAdminRoles = [
    roleService.RoleEnum.Administrator,
    roleService.RoleEnum.CountyAdministrator
]
const adminRoles = [
    roleService.RoleEnum.Administrator
]
const coronerRoles = [
    roleService.RoleEnum.CountyAdministrator,
    roleService.RoleEnum.CountyCoroner,
    roleService.RoleEnum.CountyCoronerStaff
]
const countyRoles = [
    roleService.RoleEnum.CountyAdministrator,
    roleService.RoleEnum.CountyCoroner,
    roleService.RoleEnum.CountyCoronerStaff
]

function validate (profile, roleList, countyList) {
    loggingService.log(isDebug, serviceName, 'validate')

    var result = {
        isValid: function () { return this.messageList.length === 0 },
        messageList: [] }

    validateRoleList(result, roleList)
    validateCountyList(result, roleList, countyList)

    loggingService.log(isDebug, serviceName, 'result (next line)')
    loggingService.logRaw(isDebug, result)

    return result
}

function validateRoleList (result, roleList) {
    roleList = roleList || []
    if (roleList.length === 0) {
        addMessage(result, 'User has no roles assigned')
    }
}

function validateCountyList (result, roleList, countyList) {
    roleList = roleList || []
    countyList = countyList || []
    //check county list exists if user is a county user
    if (!isAdministrator(roleList) && isCountyUser(roleList)) {
        if (countyList.length === 0) {
            addMessage(result, 'User has no counties assigned.')
        }
        if (countyList.length > 1 && countyList.filter(x => x.isPrimary).length === 0) {
            addMessage(result, 'User has no primary county assigned.')
        }
    }
}

// function validateCountyListByRole (result, roleList, role, countyList) {
//     if (hasRole(roleList, role)) {
//         if (countyList.length === 0) {
//             addMessage(result, 'User has role "' + role + '" assigned but no associated companies')
//         }
//     }
// }

function addMessage (result, message) {
    result.messageList.push(message)
    result.isValid = false
}

function hasRole (roleList, role) {
    loggingService.log(isDebug, serviceName, 'hasRole, roleList: ' + roleList + ', role: ' + role)

    roleList = roleList || []
    role = role || ''

    var foundRole = _.find(roleList, function (item) {
        return item.toUpperCase() === role.toUpperCase()
    })

    return foundRole
}

// check if user's roleList matches any of the checkRoleList
function hasRoleCheck (userRoleList, checkRoleList) {
    if (userRoleList) {
        var checkRoleListUpper = checkRoleList.map(role => role.toUpperCase())
        return userRoleList.some(role => {
            return checkRoleListUpper.includes(role.toUpperCase())
        })
    } else {
        return false
    }
}

function isAdministrator (userRoleList) {
    userRoleList = userRoleList || []
    return hasRoleCheck(userRoleList, adminRoles)
}

function isCoroner (userRoleList) {
    userRoleList = userRoleList || []
    return hasRoleCheck(userRoleList, coronerRoles)
}

function isAdminCountyAdmin (userRoleList) {
    userRoleList = userRoleList || []
    return hasRoleCheck(userRoleList, adminCountyAdminRoles)
}

function isCountyUser (userRoleList) {
    userRoleList = userRoleList || []
    return hasRoleCheck(userRoleList, countyRoles)
}

function getCurrentCoronerUserDto (http) {
    loggingService.log(isDebug, serviceName, 'getCurrentCoronerUserDto')
    return http.get(path + 'getCurrentCoronerUserDto')
}

function listPathologistUsers (http) {
    loggingService.log(isDebug, serviceName, 'listPathologistUsers')
    return http.get(path + 'ListPathologistUsers')
}

function listUserResultDtos (http, searchDto) {
    loggingService.log(isDebug, serviceName, 'listUserResultDtos')
    return http.post(path + 'ListUserResultDtos', searchDto)
}

function searchNewUsers (http, searchDto) {
    loggingService.log(isDebug, serviceName, 'searchNewUsers')
    return http.post(path + 'SearchNewUsers', searchDto)
}

function saveUser (http, userDto) {
    loggingService.log(isDebug, serviceName, 'put')
    return http.put(path + 'SaveUser', userDto)
}

function listUserCountyCoroners (http) {
    return http.get(path + 'ListUserCountyCoroners')
}

function setUserInactive (http, userDto) {
    loggingService.log(isDebug, serviceName, 'setUserInactive')
    return http.put(path + 'SetUserInactive', userDto)
}

function updateUserProfile (http, userDto) {
    loggingService.log(isDebug, serviceName, 'updateUserProfile')
    return http.put(path + 'UpdateUserProfile', userDto)
}

// function sendVerifyEmail (http) {
//     loggingService.log(isDebug, serviceName, 'SendVerifyEmail')
//     return http.post(path + 'SendVerifyEmail')
// }

export default {
    validate: validate,
    hasRole: hasRole,
    hasRoleCheck: hasRoleCheck,
    isAdministrator: isAdministrator,
    isCoroner: isCoroner,
    isAdminCountyAdmin: isAdminCountyAdmin,
    isCountyUser: isCountyUser,
    getCurrentCoronerUserDto: getCurrentCoronerUserDto,
    listPathologistUsers: listPathologistUsers,
    listUserResultDtos: listUserResultDtos,
    listUserCountyCoroners: listUserCountyCoroners,
    saveUser: saveUser,
    searchNewUsers: searchNewUsers,
    setUserInactive: setUserInactive,
    updateUserProfile: updateUserProfile
    // sendVerifyEmail: sendVerifyEmail
}
